import { FC } from "react";

import { IRideDto } from "@ryde/shared";

import { VehicleOccupancyIconAndColoredLabel } from "../../../../common";
import { VehicleOccupancyWrapperStyled } from "./summary.rides.styled";

interface ISummaryLoadBusInfoRides {
  rideDto: IRideDto | null | undefined;
}

export const VehicleOccupancyRides: FC<ISummaryLoadBusInfoRides> = ({
  rideDto,
}): JSX.Element => {
  return (
    <VehicleOccupancyWrapperStyled>
      {!!rideDto?.occupancy && (
        <VehicleOccupancyIconAndColoredLabel
          $busOccupancy={rideDto.occupancy}
          vehicleCapacity={rideDto.metadata?.maxPassengers}
          seatsCount={rideDto.metadata?.seatsCount}
          rideStatus={rideDto.status}
        />
      )}
    </VehicleOccupancyWrapperStyled>
  );
};
